<template>
  <div class="contentBox basic-padding-left-right"
       :style="{
       backgroundImage: backgroundImgName? 'url(' +$imgUrl+ backgroundImageList[backgroundImgName] + ')':'',
       backgroundColor: backgroundColor,
       }">
    <div class="main-title">
      <div class="title" :style="{color: whiteTitle?'white':''}">{{ title }}</div>
      <div class="sub-title" :style="{color: whiteTitle?'white':''}">{{ subTitle }}</div>
      <div class="line" :style="{background: whiteTitle?'white':''}"></div>
    </div>
    <slot></slot>
  </div>

</template>
<script>
export default {
  name: 'contentBox',
  props: {
    height: {
      type: String,
      default: '800px'
    },
    title: {
      type: String,
      default: '企业简介'
    },
    subTitle: {
      type: String,
      default: 'Company Introduction'
    },
    backgroundImgName: {
      type: String,
      default: ''
    },
    whiteTitle:{
      type: Boolean,
      default: false
    },
    backgroundColor:{
      type: String,
      default: '#ffffff'
    }
  },
  data() {
    return {
      backgroundImageList: {
        coreTechnology: 'coreTechnology-bg.png',
        coreProductsAndServices: 'coreProductsAndServices-bg.png',
        latestNews: 'latestNews-bg.png',
        core: 'core-bg.png',
      },
      loading:true
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false
    },500)
  }
}
</script>
<style lang="less" scoped>
.contentBox {
  width: 100%;
  box-sizing: border-box;
  position: relative;
  background-size: 100% 100%;
  padding-bottom: 40px;

  .main-title {
    position: absolute;
    top: 70px;
    left: 3.5%;
    display: flex;
    flex-direction: column;
    transition: all 0.3s;
    .title {
      font-weight: 500;
      font-size: 40px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 56px;
    }

    .sub-title {
      font-weight: 500;
      font-size: 20px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 28px;
    }

    .line {
      margin-top: 20px;
      width: 20px;
      height: 3px;
      background: #020202;
    }
  }

}
/* 在最小宽度为1200像素时应用这些样式 */
@media only screen and (min-width: 1600px) {
  .main-title {
    left: 12.5%!important;
  }
}
</style>